import dayjs from 'dayjs'
import nb from 'dayjs/locale/nb'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import isoWeek from 'dayjs/plugin/isoWeek'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import localeData from 'dayjs/plugin/localeData'
import minmax from 'dayjs/plugin/minMax'
import objectSupport from 'dayjs/plugin/objectSupport'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import updateLocale from 'dayjs/plugin/updateLocale'
import utc from 'dayjs/plugin/utc'

import { getNowConfig } from './helpers/getNow'

export const HOSPITAL_TIMEZONE = 'Europe/Oslo'

export const ZERO_DURATION_TOKEN = 'P0DT0H00M0.000000S'

export function initDayjs(options?: { today?: string }) {
    if (options?.today) {
        getNowConfig.mockedNow = options.today
    }
    dayjs.locale(nb)
    dayjs.extend(updateLocale)
    dayjs.updateLocale('nb', {
        weekStart: 1,
        weekdaysShort: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
    })
    dayjs.extend(customParseFormat)
    dayjs.extend(duration)
    dayjs.extend(relativeTime)
    dayjs.extend(utc)
    dayjs.extend(timezone)
    dayjs.extend(isoWeek)
    dayjs.extend(isBetween)
    dayjs.extend(isSameOrAfter)
    dayjs.extend(isSameOrBefore)
    dayjs.extend(minmax)
    dayjs.extend(objectSupport)
    dayjs.extend(localeData)

    dayjs.tz.setDefault(HOSPITAL_TIMEZONE)
}

initDayjs({ today: import.meta.env.VITE_TODAY })
